<template>
  <nav class="sub-sub-menu-nav">
    <ul class="sub-sub-menu">
      <li class="sub-sub-menu-item">
        <span class="text-sm md:text-base font-bold text-primary m-0 my-2 sm:my-0 px-4 md:px-6">Reports</span>
      </li>
      <li class="sub-sub-menu-item">
        <router-link
          class="sub-sub-menu-item-link"
          :to="{ name: 'SiteAdminReportsDashboard' }"
          @click.prevent="gotoRoute({ name: 'SiteAdminReportsDashboard' })"
          ><IconDashboard class="w-6 h-6"
        /></router-link>
      </li>
      <li class="sub-sub-menu-item">
        <router-link
          class="sub-sub-menu-item-link"
          :to="{ name: 'SiteAdminReportsAllLicenceLevels' }"
          @click.prevent="gotoRoute({ name: 'SiteAdminReportsAllLicenceLevels' })"
          >All Licence Levels</router-link
        >
      </li>
      <li class="sub-sub-menu-item">
        <router-link
          class="sub-sub-menu-item-link"
          :to="{ name: 'SiteAdminReportsLicenceLevels' }"
          @click.prevent="gotoRoute({ name: 'SiteAdminReportsLicenceLevels' })"
          >Low Licence Levels</router-link
        >
      </li>
      <li class="sub-sub-menu-item">
        <router-link
          class="sub-sub-menu-item-link"
          :to="{ name: 'SiteAdminReportsCertificateExpiries' }"
          @click.prevent="gotoRoute({ name: 'SiteAdminReportsCertificateExpiries' })"
          >Certificate Expiry</router-link
        >
      </li>
      <li class="sub-sub-menu-item">
        <router-link
          class="sub-sub-menu-item-link"
          :to="{ name: 'SiteAdminReportsCourseResults' }"
          @click.prevent="gotoRoute({ name: 'SiteAdminReportsCourseResults' })"
          >Course Results</router-link
        >
      </li>
      <li class="sub-sub-menu-item">
        <router-link
          class="sub-sub-menu-item-link"
          :to="{ name: 'SiteAdminReportsAssessmentsDue' }"
          @click.prevent="gotoRoute({ name: 'SiteAdminReportsAssessmentsDue' })"
          >Assessments Due</router-link
        >
      </li>
      <li class="sub-sub-menu-item">
        <router-link
          class="sub-sub-menu-item-link"
          :to="{ name: 'SiteAdminGroupLicenceRequests' }"
          @click.prevent="gotoRoute({ name: 'SiteAdminGroupLicenceRequests' })"
          >Licence Requests</router-link
        >
      </li>
      <li class="sub-sub-menu-item">
        <router-link
          class="sub-sub-menu-item-link"
          :to="{ name: 'SiteAdminReportsGroupTrainingRecords' }"
          @click.prevent="gotoRoute({ name: 'SiteAdminReportsGroupTrainingRecords' })"
          >Training Records</router-link
        >
      </li>
    </ul>
  </nav>
</template>
<script>
export default {
  methods: {
    gotoRoute(route) {
      this.$router.push(route);
      this.$store.commit("closeMobileMenu");
    }
  }
};
</script>
